module.exports = __webpack_public_path__ + "static/media/info-square.9b9bbe45.svg";